import { faSave } from "@fortawesome/pro-solid-svg-icons"
import { useContext } from "react"
import { Outlet, useMatches, useParams } from "react-router-dom"
import HeroButton from "../../components/common/HeroButton"
import HeroButtonsContainer from "../../components/common/HeroButtonsContainer"
import HeroContainer from "../../components/common/HeroContainer"
import { SetupContext } from "./SetupContext"
import SetupSidebar from "./SetupSidebar"
import { AuthenticationContext } from "../../AuthenticationContext"

const SetupRoot = () => {
  const { currentUser } = useContext(AuthenticationContext)
  const heroImage = currentUser?.tenant.publicFolderUrl + '/images/default-setup.jpg'

  const params = useParams()
  const matches = useMatches()
  const {
    title = 'Setup',
    showSaveButton = false,
    showHero = true
  } = (matches[matches.length - 1].handle as any) ?? {}

  const { save, hasChanges } = useContext(SetupContext)

  const getTitle = () => {
    if (typeof title === 'function') {
      return title(params)
    }
    return title
  }

  return <>
    <SetupSidebar />
    <div id="main" className="has-elements fluid-container">
      {showHero && <>
        <HeroContainer imgSrc={heroImage} />
        <div className="hero-details">
          <h1>{getTitle()}</h1>
          <HeroButtonsContainer>
            {showSaveButton && <HeroButton icon={faSave} onClick={save} disabled={!hasChanges} />}
          </HeroButtonsContainer>
        </div>
        <section>
          <Outlet />
        </section>
      </>}
      {!showHero && <Outlet />}
    </div>
  </>
}

export default SetupRoot
